var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"limtedCover"},[_c('img',{attrs:{"src":_vm.resdata.img,"alt":"111"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }